import React, { Component } from 'react';
import {
	ITableProps,
	ITableState,
} from './models';
import { inject, observer } from 'mobx-react';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';
import Wrapper from './styledComponents/Wrapper';
import TableComponent from '@kurtosys/ksys-app-components/dist/components/base/Table';
import Breakpoint from '@kurtosys/ksys-app-components/dist/components/base/Breakpoint';
import { computed } from 'mobx';

@inject('appStore', 'tableStore')
@observer
export class Table extends Component<ITableProps, ITableState> {
	static configurationKey: 'table' = 'table';
	static styleKey: 'table' = 'table';
	constructor(props: ITableProps) {
		super(props);
	}

	@computed
	get renderContent() {
		const { tableStore } = this.props;
		if (tableStore) {
			const { breakpoints } = tableStore;
			if (breakpoints) {
				return breakpoints.map((breakpoint) => {
					const breakpointProps = {
						key: `${ breakpoint.size }_${ breakpoint.modifier }`,
						[breakpoint.size]: true,
						[breakpoint.modifier]: true,
					};
					return (
						<Breakpoint { ...breakpointProps } >
							<TableComponent { ...breakpoint.props } />
						</Breakpoint>
					);
				});
			}
			return null;
		}
	}

	render() {
		const { className, tableStore } = this.props;

		if (!tableStore) {
			return null;
		}

		return (
			<Wrapper className={ className }>
				{ this.renderContent }
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(Table, 'table');

